export default "__VITE_ASSET__e674baed__"